/* ============================================================
   CONTT.s Fitness — theme.js
   Comportamentos do protótipo + carrinho REAL do Shopify (AJAX)
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  /* ===================== CARRINHO (Shopify AJAX) ===================== */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }
  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ===================== VISTOS RECENTEMENTE ===================== */
  var RECENT_KEY = 'contt_recent';
  function getRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  window.CONTT_recordView = function (p) {
    if (!p || !p.id) return;
    try {
      var list = getRecent().filter(function (x) { return x && x.id !== p.id; });
      list.unshift(p);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  };
  function recentCardsHTML(cart) {
    var inCart = {};
    ((cart && cart.items) || []).forEach(function (i) { inCart[i.product_id] = 1; });
    var out = [], list = getRecent();
    for (var k = 0; k < list.length && out.length < 4; k++) {
      var p = list[k];
      if (!p || !p.variant || !p.available || inCart[p.id]) continue;
      var action = '<div class="mc-xs__sizes" aria-label="tamanhos">';
      if (p.sizes && p.sizes.length) {
        for (var s = 0; s < p.sizes.length; s++) { action += '<button type="button" class="mc-xs__size" data-variant="' + p.sizes[s].v + '" aria-label="tamanho ' + p.sizes[s].l + '">' + p.sizes[s].l + '</button>'; }
      } else {
        action += '<button type="button" class="mc-xs__size mc-xs__size--uni" data-variant="' + p.variant + '" aria-label="tamanho único">único</button>';
      }
      action += '</div><button type="button" class="mc-xs__add" data-add-xs>adicionar ao carrinho</button>';
      out.push(
        '<div class="mc-xs__card">' +
        '<a class="mc-xs__img" href="' + p.url + '">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a class="mc-xs__name" href="' + p.url + '">' + (p.title || '') + '</a>' +
        '<div class="mc-xs__price">' + money(p.price) + '</div>' +
        action +
        '</div>'
      );
    }
    return out.length ? out.join('') : null;
  }
  function updateSeen(cart) {
    var sec = $('#mcSeen'), grid = $('#mcSeenGrid'); if (!sec || !grid) return;
    var html = recentCardsHTML(cart);
    if (html) { grid.innerHTML = html; sec.hidden = false; }
    else { grid.innerHTML = ''; sec.hidden = true; }
  }

  /* taxas de frete REAIS do checkout (Melhor Envio/Correios) p/ o carrinho atual.
     O endpoint síncrono exige estado+cidade, então buscamos pelo CEP (ViaCEP) antes. */
  function shippingRates(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (loc) {
        if (!loc || loc.erro) return [];
        var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(cep) +
          '&shipping_address%5Bcountry%5D=Brazil' +
          '&shipping_address%5Bprovince%5D=' + encodeURIComponent(loc.uf || '') +
          '&shipping_address%5Bcity%5D=' + encodeURIComponent(loc.localidade || '');
        return fetch('/cart/shipping_rates.json?' + q, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var rates = (d && d.shipping_rates) ? d.shipping_rates : [];
            rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
            /* retirada no local grátis: sempre, no FINAL da lista */
            rates.push({ name: 'Retirada no local', price: '0.00', pickup: true });
            return rates;
          });
      });
  }
  /* nome curto do transportador (sem o nome comprido do app) */
  function shortCarrier(name) {
    var s = (name || '').toLowerCase();
    if (s.indexOf('grátis') > -1 || s.indexOf('gratis') > -1 || s.indexOf('free') > -1) return 'Frete Grátis';
    if (s.indexOf('jadlog') > -1) return 'Jadlog';
    if (s.indexOf('loggi') > -1) return 'Loggi';
    if (s.indexOf('sedex') > -1) return 'Correios SEDEX';
    if (s.indexOf('pac') > -1) return 'Correios PAC';
    if (s.indexOf('correios') > -1) return 'Correios';
    if (s.indexOf('azul') > -1) return 'Azul Cargo';
    if (s.indexOf('latam') > -1) return 'LATAM';
    if (s.indexOf('jet') > -1 || s.indexOf('j&t') > -1) return 'J&T Express';
    return (name || '').split(' ')[0];
  }

  /* monta a lista de opções de frete (nome + prazo por datas + valor); destaca o grátis */
  function freightRatesHtml(rates) {
    var truck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>';
    var pin = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>';
    var rows = rates.map(function (r) {
      var n = parseFloat(r.price);
      var free = !n;
      if (r.pickup) {
        return '<div class="freight__opt freight__opt--pickup"><span>' + pin +
          '<span class="freight__pk">Retirada no local' +
          '<small>Av. Central, 46 - Bloco B</small>' +
          '<b class="freight__pk-hours">10h às 17h30</b></span></span>' +
          '<b class="freight__free">grátis</b></div>';
      }
      var name = shortCarrier(r.name);
      var val = free ? '<b class="freight__free">grátis</b>' : '<b>R$ ' + n.toFixed(2).replace('.', ',') + '</b>';
      var prazo = '', dr = r.delivery_range;
      if (dr && dr.length === 2 && dr[0] && dr[1]) {
        var d = function (s) { var m = String(s).slice(0, 10).split('-'); return m[2] + '/' + m[1]; };
        prazo = (dr[0] === dr[1]) ? ('até ' + d(dr[1])) : (d(dr[0]) + '–' + d(dr[1]));
      } else if (r.delivery_days && r.delivery_days.length) {
        var dd = r.delivery_days, a = dd[0], b = dd[dd.length - 1];
        prazo = (a === b) ? (a + ' dias úteis') : (a + ' a ' + b + ' dias úteis');
      }
      var icon = free ? truck : '';
      var cls = 'freight__opt' + (free ? ' freight__opt--free' : '');
      return '<div class="' + cls + '"><span>' + icon + name + (prazo ? ' <small>' + prazo + '</small>' : '') + '</span>' + val + '</div>';
    }).join('');
    return rows + '<div class="freight__note">taxas e prazos reais · Correios e transportadoras.</div>';
  }

  /* ===== persistência reforçada: backup do carrinho em localStorage =====
     O carrinho do Shopify já persiste por cookie (~14 dias). Este backup
     NÃO expira: se o cliente voltar com o carrinho vazio mas houver itens
     salvos (cookie perdido/expirado), os itens são restaurados automaticamente.

     Guardamos junto o TOKEN do carrinho. Ele é o que diferencia as duas
     situações em que o carrinho chega vazio:
       - token igual ao do backup  -> é o mesmo carrinho, a cliente esvaziou
                                      de propósito (removeu itens na sacola).
                                      NÃO restaura, descarta o backup.
       - token diferente/ausente   -> é outro carrinho, o cookie se perdeu.
                                      Restaura os itens.
     Sem isso, remover o último item na página da sacola era desfeito no
     recarregamento e a cliente não conseguia esvaziar o carrinho. */
  var CART_BACKUP_KEY = 'contts_cart_backup_v2';
  try { localStorage.removeItem('contts_cart_backup_v1'); } catch (e) {}
  function saveBackup(cart) {
    try {
      var items = (cart && cart.items) ? cart.items.map(function (i) { return { id: i.id, q: i.quantity }; }) : [];
      localStorage.setItem(CART_BACKUP_KEY, JSON.stringify({ token: (cart && cart.token) || '', items: items }));
    } catch (e) {}
  }
  function loadBackup() {
    try {
      var o = JSON.parse(localStorage.getItem(CART_BACKUP_KEY) || 'null');
      if (!o || !Array.isArray(o.items)) return { token: '', items: [] };
      return { token: o.token || '', items: o.items.filter(function (x) { return x && x.id && x.q > 0; }) };
    } catch (e) { return { token: '', items: [] }; }
  }
  function clearBackup() { try { localStorage.removeItem(CART_BACKUP_KEY); } catch (e) {} }
  function restoreBackup() {
    var items = loadBackup().items;
    if (!items.length) return Promise.resolve(false);
    return items.reduce(function (p, x) {
      return p.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: x.id, quantity: x.q }) }).catch(function () {});
      });
    }, Promise.resolve()).then(function () { return true; });
  }

  function syncCartCount(cart) {
    var n = cart ? cart.item_count : 0;
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; });
  }

  function renderMinicart(cart) {
    var body = $('#mcBody'), foot = $('#mcFoot');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="minicart__empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 6h15l-1.5 9h-12z"/><path d="M6 6L5 2H2"/><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/></svg>' +
        '<p>nenhum produto na sua sacola</p>' +
        '<a href="/collections/all">continuar comprando</a></div>';
      if (foot) foot.style.display = 'none';
      var mcE = $('#minicart'); if (mcE) mcE.classList.remove('has-items');
      var sb0 = $('#shipBar'); if (sb0) sb0.hidden = true;
      var sn0 = $('#mcSeen'); if (sn0) sn0.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (i) {
      var variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
      return '<div class="mc-item" data-key="' + i.key + '">' +
        '<img class="mc-item__img" src="' + (i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_140x$1$2') : '') + '" alt="">' +
        '<div class="mc-item__info">' +
        '<div class="mc-item__name">' + i.product_title + '</div>' +
        (variant ? '<div class="mc-item__meta">' + variant + '</div>' : '') +
        '<div class="mc-item__price">' + money(i.final_line_price) + '</div>' +
        '<div class="mc-item__qty"><button data-dec aria-label="menos">−</button><span>' + i.quantity + '</span><button data-inc aria-label="mais">+</button></div>' +
        '</div>' +
        '<button class="mc-item__remove" data-rm>remover</button>' +
        '</div>';
    }).join('');
    if (foot) { foot.style.display = 'block'; var t = $('#mcTotal'); if (t) t.textContent = money(cart.total_price); }
    var mcF = $('#minicart'); if (mcF) mcF.classList.add('has-items');
    updateShipBar(cart);
    updateSeen(cart);
  }

  /* limite de frete grátis: vem de settings.free_shipping_threshold (ponte em layout/theme.liquid) */
  var FREE_SHIP = (window.CONTT_SETTINGS && window.CONTT_SETTINGS.freeShip) || 19900;
  function updateShipBar(cart) {
    var sb = $('#shipBar'); if (!sb) return;
    var tot = cart.total_price || 0;
    if (tot >= FREE_SHIP) {
      sb.className = 'ship-bar is-free';
      sb.innerHTML = '<div class="ship-bar__msg"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="18.5" cy="18.5" r="2"/></svg>você ganhou frete grátis!</div>';
    } else {
      var falta = FREE_SHIP - tot;
      var pct = Math.min(100, Math.round(tot / FREE_SHIP * 100));
      sb.className = 'ship-bar';
      sb.innerHTML = '<div class="ship-bar__txt">faltam <b>' + money(falta) + '</b> para o <b>frete grátis</b></div>' +
        '<div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
    }
    sb.hidden = false;
  }

  function refreshCart(open) {
    return getCart().then(function (cart) {
      syncCartCount(cart); renderMinicart(cart);
      if (open) openMinicart();
      return cart;
    });
  }
  function openMinicart() { var m = $('#minicart'); if (m) m.classList.add('open'); }
  function closeMinicart() { var m = $('#minicart'); if (m) m.classList.remove('open'); }
  /* expõe p/ outros scripts (ex.: "comprar tudo" do compre junto) adicionarem e abrirem a sacola */
  window.CONTT_refreshCart = refreshCart;
  window.CONTT_openCart = openMinicart;

  /* ===================== DOM READY ===================== */
  document.addEventListener('DOMContentLoaded', function () {
    /* hidrata o minicart; se o carrinho estiver vazio mas houver backup salvo, restaura os itens */
    getCart().then(function (cart) {
      var bk = loadBackup();
      if (cart.item_count === 0 && bk.items.length) {
        /* mesmo carrinho => foi a cliente que esvaziou: respeita e descarta o backup */
        if (bk.token && bk.token === cart.token) {
          clearBackup();
        } else {
          return restoreBackup().then(function () { return refreshCart(false); }).then(function (c) { saveBackup(c); });
        }
      }
      syncCartCount(cart); renderMinicart(cart);
      if (cart.item_count > 0) saveBackup(cart);
    }).catch(function () { refreshCart(false); });

    /* announcement carousel */
    (function () {
      var slides = $$('.announce__slide'); if (slides.length < 2) return;
      var i = 0, timer;
      function show(n) { slides[i].classList.remove('active'); i = (n + slides.length) % slides.length; slides[i].classList.add('active'); }
      function start() { timer = setInterval(function () { show(i + 1); }, 4000); }
      function reset() { clearInterval(timer); start(); }
      var nx = $('#annNext'), pv = $('#annPrev');
      if (nx) nx.addEventListener('click', function () { show(i + 1); reset(); });
      if (pv) pv.addEventListener('click', function () { show(i - 1); reset(); });
      start();
    })();

    /* sticky navbar */
    (function () { var nav = $('#navbar'); if (!nav) return; var top = nav.offsetTop; window.addEventListener('scroll', function () { nav.classList.toggle('stuck', window.scrollY > top); }); })();

    /* back to top */
    (function () { var t = $('#toTop'); if (!t) return; window.addEventListener('scroll', function () { t.classList.toggle('show', window.scrollY > 600); }); t.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); })();

    /* mobile drawer */
    (function () { var d = $('#mdrawer'); if (!d) return; var o = $('#hamburger'), c = $('#mdClose'), s = d.querySelector('.mdrawer__scrim'); if (o) o.addEventListener('click', function () { d.classList.add('open'); }); if (c) c.addEventListener('click', function () { d.classList.remove('open'); }); if (s) s.addEventListener('click', function () { d.classList.remove('open'); }); })();

    /* minicart open/close + qty controls */
    (function () {
      var m = $('#minicart'); if (!m) return;
      var s = m.querySelector('.minicart__scrim'), c = $('#mcClose');
      $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); }); });
      if (s) s.addEventListener('click', closeMinicart);
      if (c) c.addEventListener('click', closeMinicart);
      var body = $('#mcBody');
      if (body) body.addEventListener('click', function (e) {
        var item = e.target.closest('.mc-item'); if (!item) return; var key = item.dataset.key;
        var span = item.querySelector('.mc-item__qty span'); var q = span ? parseInt(span.textContent, 10) : 1;
        var nq = null;
        if (e.target.closest('[data-inc]')) nq = q + 1;
        else if (e.target.closest('[data-dec]')) nq = q - 1;
        else if (e.target.closest('[data-rm]')) nq = 0;
        else return;
        changeLine(key, nq).then(function (cart) { syncCartCount(cart); renderMinicart(cart); saveBackup(cart); if (window.CONTT_onCartChange) window.CONTT_onCartChange(cart); });
      });

      /* cross-sell (vistos / veja também): selecionar tamanho + botão "adicionar ao carrinho" */
      var mcPanel = $('#minicart');
      if (mcPanel) mcPanel.addEventListener('click', function (e) {
        var pick = e.target.closest('.mc-xs__size[data-variant]');
        if (pick) {
          e.preventDefault();
          var grp = pick.closest('.mc-xs__sizes');
          if (grp) grp.querySelectorAll('.mc-xs__size').forEach(function (b) { b.classList.remove('selected'); });
          pick.classList.add('selected');
          return;
        }
        var xa = e.target.closest('[data-add-xs]');
        if (xa) {
          e.preventDefault();
          var card = xa.closest('.mc-xs__card');
          var all = card ? card.querySelectorAll('.mc-xs__size[data-variant]') : [];
          var sel = card ? card.querySelector('.mc-xs__size.selected[data-variant]') : null;
          var target = sel || (all.length === 1 ? all[0] : null);
          if (!target) { var szs = card ? card.querySelector('.mc-xs__sizes') : null; if (szs) { szs.classList.add('shake'); setTimeout(function () { szs.classList.remove('shake'); }, 450); } return; }
          var vid = target.getAttribute('data-variant'); if (!vid) return;
          var oldt = xa.textContent; xa.disabled = true; xa.textContent = 'adicionando...';
          addToCart(vid, 1).then(function () { return refreshCart(true); }).then(function (cart) { if (typeof saveBackup === 'function') saveBackup(cart); })
            .catch(function () { xa.disabled = false; xa.textContent = oldt; alert('Não foi possível adicionar ao carrinho.'); });
          return;
        }
      });

      /* simulador de frete no drawer (tarifas reais do checkout: Melhor Envio) */
      (function () {
        var input = $('#mcCep'), btn = $('#mcCepCalc'), box = $('#mcCepResult');
        if (!input || !btn) return;
        function show(html, cls) { if (!box) return; box.className = 'minicart__ship-result' + (cls ? ' ' + cls : ''); box.innerHTML = html; box.hidden = false; }
        function run() {
          var cep = (input.value || '').replace(/\D/g, '');
          if (cep.length !== 8) { show('digite um CEP válido (8 dígitos).', 'err'); return; }
          btn.disabled = true; var old = btn.textContent; btn.textContent = '...';
          show('calculando frete…', 'loading');
          shippingRates(cep).then(function (rates) {
            btn.disabled = false; btn.textContent = old;
            show(rates.length ? freightRatesHtml(rates) : 'nenhuma opção de frete para este CEP.', rates.length ? 'ok' : 'err');
          }).catch(function () { btn.disabled = false; btn.textContent = old; show('não foi possível calcular agora. tente de novo.', 'err'); });
        }
        input.addEventListener('input', function () { var v = input.value.replace(/\D/g, '').slice(0, 8); input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
        btn.addEventListener('click', run);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      })();
    })();

    /* add-to-cart (cards) via delegação */
    document.body.addEventListener('click', function (e) {
      /* 1) seleção de tamanho no card (apenas destaca; adicionar é no botão abaixo) */
      var pick = e.target.closest('.pcard__size[data-variant]');
      if (pick) {
        e.preventDefault();
        var grp = pick.closest('.pcard__sizes');
        if (grp) grp.querySelectorAll('.pcard__size').forEach(function (b) { b.classList.remove('selected'); });
        pick.classList.add('selected');
        return;
      }
      /* 2) botão "adicionar ao carrinho" do card: usa o tamanho selecionado */
      var addc = e.target.closest('[data-add-card]');
      if (addc) {
        e.preventDefault();
        var pc = addc.closest('.pcard');
        var sel = pc ? pc.querySelector('.pcard__size.selected[data-variant]') : null;
        if (!sel) {
          var szs = pc ? pc.querySelector('.pcard__sizes') : null;
          if (szs) { szs.classList.add('shake'); setTimeout(function () { szs.classList.remove('shake'); }, 450); }
          return;
        }
        var vid = sel.getAttribute('data-variant'); if (!vid) return;
        var oldt = addc.textContent; addc.disabled = true; addc.textContent = 'adicionando...';
        addToCart(vid, 1).then(function () { return refreshCart(true); }).then(function (cart) { if (typeof saveBackup === 'function') saveBackup(cart); addc.textContent = 'adicionado ✓'; setTimeout(function () { addc.textContent = oldt; addc.disabled = false; }, 1200); })
          .catch(function () { addc.textContent = oldt; addc.disabled = false; alert('Não foi possível adicionar ao carrinho.'); });
        return;
      }
      var add = e.target.closest('[data-add]');
      if (add) {
        e.preventDefault(); var id = add.getAttribute('data-add'); if (!id) return;
        /* chip de tamanho no "veja também": não troca texto (estouraria), só marca e adiciona */
        if (add.classList.contains('mc-xs__size')) {
          add.disabled = true; add.classList.add('is-added');
          addToCart(id, 1).then(function () { return refreshCart(true); }).then(function (cart) { if (typeof saveBackup === 'function') saveBackup(cart); })
            .catch(function () { add.disabled = false; add.classList.remove('is-added'); alert('Não foi possível adicionar ao carrinho.'); });
          return;
        }
        var old = add.textContent; add.disabled = true; add.textContent = 'adicionando...';
        addToCart(id, 1).then(function () { return refreshCart(true); }).then(function (cart) { saveBackup(cart); add.textContent = 'adicionado ✓'; setTimeout(function () { add.textContent = old; add.disabled = false; }, 1200); })
          .catch(function () { add.textContent = old; add.disabled = false; alert('Não foi possível adicionar ao carrinho.'); });
        return;
      }
      var w = e.target.closest('[data-wish]'); if (w) { e.preventDefault(); wishMark(w, wishToggle(w.getAttribute('data-wish'))); return; }
    });

    /* favoritos de verdade (localStorage): o coração salva o produto e volta preenchido ao recarregar/voltar */
    function wishGet() { try { return JSON.parse(localStorage.getItem('ct_wishlist') || '[]'); } catch (e) { return []; } }
    function wishSet(a) { try { localStorage.setItem('ct_wishlist', JSON.stringify(a)); } catch (e) {} }
    function wishToggle(h) { var a = wishGet(), i = a.indexOf(h); if (i >= 0) { a.splice(i, 1); } else { a.push(h); } wishSet(a); return i < 0; }
    function wishMark(el, on) { el.classList.toggle('active', on); el.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    function wishSync() { var a = wishGet(); $$('[data-wish]').forEach(function (el) { wishMark(el, a.indexOf(el.getAttribute('data-wish')) >= 0); }); }
    wishSync();

    /* ao iniciar o checkout, limpa o backup para não restaurar itens já comprados */
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('[name="checkout"], a[href*="/checkout"], [data-checkout]')) clearBackup();
    });

    /* Mexer no carrinho pela PÁGINA da sacola é navegação: some do JS, recarrega e
       o backup poderia repor o que a cliente acabou de tirar. A comparação de token
       lá em cima já cobre isso; aqui zeramos na hora, para não depender de o
       /cart.js devolver token. Se sobrar item, o saveBackup do reload regrava. */
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('a[href*="/cart/change"], a[href*="/cart/clear"], [name="update"], [name="clear"]')) clearBackup();
    });

    /* newsletter / no-op forms */
    $$('form[data-thanks]').forEach(function (f) { f.addEventListener('submit', function (e) { e.preventDefault(); alert('Tudo certo! ' + f.getAttribute('data-thanks')); if (f.reset) f.reset(); }); });

    /* carousels horizontais */
    $$('.carousel').forEach(function (c) {
      var track = c.querySelector('.carousel__track'); if (!track) return;
      var prev = c.querySelector('.carousel__arrow--prev'), next = c.querySelector('.carousel__arrow--next');
      function step() { var f = track.firstElementChild; return f ? (f.getBoundingClientRect().width + 16) : 300; }
      /* scrollBy({behavior:'smooth'}) é ignorado quando há scroll-snap mandatory;
         então animamos via rAF desligando o snap durante o movimento e religando no fim */
      var animating = false;
      function animateTo(target) {
        var max = track.scrollWidth - track.clientWidth;
        target = Math.max(0, Math.min(target, max));
        var start = track.scrollLeft, dist = target - start;
        if (Math.abs(dist) < 1 || animating) return;
        animating = true;
        var snap = track.style.scrollSnapType, beh = track.style.scrollBehavior;
        track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto';
        var t0 = null, dur = 380;
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          track.scrollLeft = start + dist * e;
          if (p < 1) { requestAnimationFrame(frame); }
          else { track.style.scrollSnapType = snap; track.style.scrollBehavior = beh; animating = false; }
        }
        requestAnimationFrame(frame);
      }
      if (next) next.addEventListener('click', function () { animateTo(track.scrollLeft + step() * 2); });
      if (prev) prev.addEventListener('click', function () { animateTo(track.scrollLeft - step() * 2); });
    });

    /* hero carousel */
    $$('[data-hero]').forEach(function (hero) {
      var track = hero.querySelector('.hero__track'); if (!track) return;
      var slides = track.children.length; if (!slides) return;
      var dots = hero.querySelector('.hero__dots'); var i = 0, timer;
      if (dots) for (var k = 0; k < slides; k++) { var b = document.createElement('button'); b.setAttribute('aria-label', 'slide ' + (k + 1)); dots.appendChild(b); }
      var dotEls = dots ? dots.children : [];
      function go(n) { i = (n + slides) % slides; track.style.transform = 'translateX(-' + (i * 100) + '%)'; for (var k = 0; k < dotEls.length; k++) dotEls[k].classList.toggle('active', k === i); }
      for (var k = 0; k < dotEls.length; k++)(function (idx) { dotEls[idx].addEventListener('click', function () { go(idx); reset(); }); })(k);
      var nx = hero.querySelector('.hero__arrow--next'), pv = hero.querySelector('.hero__arrow--prev');
      if (nx) nx.addEventListener('click', function () { go(i + 1); reset(); });
      if (pv) pv.addEventListener('click', function () { go(i - 1); reset(); });
      function start() { if (slides > 1) timer = setInterval(function () { go(i + 1); }, 6000); }
      function reset() { clearInterval(timer); start(); }
      go(0); start();
    });

    /* ===== PÁGINA DE PRODUTO: variações + preço + comprar ===== */
    (function () {
      var root = $('#product-form'); if (!root || !window.__ctProduct) return;
      var data = window.__ctProduct, idInput = $('#variant-id', root), buyBtn = $('#buyBtn', root);
      function selectedValues() { var v = []; for (var p = 1; p <= data.optionCount; p++) { var s = $('[data-opt="' + p + '"].selected'); v.push(s ? s.getAttribute('data-value') : null); } return v; }
      function findVariant(vals) { return data.variants.find(function (vt) { for (var i = 0; i < vals.length; i++) { if (vals[i] == null || vt.options[i] !== vals[i]) return false; } return true; }); }
      function update() {
        var vv = findVariant(selectedValues()); if (!vv) return;
        if (idInput) idInput.value = vv.id;
        data.price = vv.price;
        var pix = $('#price-pix-val'), card = $('#price-card-val'), inst = $('#price-install-val');
        if (pix) pix.textContent = money(Math.round(vv.price * 0.95));
        if (card) card.textContent = money(vv.price);
        if (inst) inst.textContent = money(Math.round(vv.price / 6));
        if (buyBtn) { if (vv.available) { buyBtn.disabled = false; buyBtn.textContent = 'comprar'; } else { buyBtn.disabled = true; buyBtn.textContent = 'esgotado'; } }
      }
      /* disponibilidade combinada: marca tamanhos sem estoque considerando a cor escolhida.
         Vale p/ qualquer nº de opções (antes só marcava produtos de 1 opção). */
      function optAvailable(pos, value) {
        var sel = selectedValues();
        return data.variants.some(function (vt) {
          if (!vt.available || vt.options[pos - 1] !== value) return false;
          for (var i = 0; i < sel.length; i++) { if (i === pos - 1) continue; if (sel[i] != null && vt.options[i] !== sel[i]) return false; }
          return true;
        });
      }
      function refreshSizeAvail() {
        $$('#variant-options .size-btn[data-opt]').forEach(function (b) {
          b.classList.toggle('disabled', !optAvailable(+b.getAttribute('data-opt'), b.getAttribute('data-value')));
        });
      }
      /* se o tamanho selecionado ficou indisponível p/ a nova cor, pula pro 1º válido — nunca trava em "esgotado" havendo combinação */
      function ensureValidSize() {
        var cur = $('#variant-options .size-btn.selected');
        if (cur && !cur.classList.contains('disabled')) return;
        var ok = $$('#variant-options .size-btn').filter(function (x) { return !x.classList.contains('disabled'); })[0];
        if (!ok) return;
        var p = ok.getAttribute('data-opt');
        $$('[data-opt="' + p + '"]').forEach(function (x) { x.classList.remove('selected'); });
        ok.classList.add('selected');
      }
      refreshSizeAvail();
      $$('#variant-options [data-opt]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('disabled')) return;
          var p = b.getAttribute('data-opt');
          $$('[data-opt="' + p + '"]').forEach(function (x) { x.classList.remove('selected'); });
          b.classList.add('selected');
          if (b.classList.contains('color-btn')) {
            var cl = $('#colorLabelVal'); if (cl) cl.textContent = (b.getAttribute('data-value') || '').toLowerCase();
            refreshSizeAvail(); ensureValidSize();
          }
          update();
        });
      });
      /* adicionar ao carrinho SEM sair da página: intercepta o submit, adiciona via AJAX e abre o minicart */
      root.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = idInput ? idInput.value : null; if (!id) return;
        var prev = buyBtn ? buyBtn.textContent : '';
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'adicionando...'; }
        addToCart(id, 1).then(function () { return refreshCart(true); }).then(function (cart) {
          if (typeof saveBackup === 'function') saveBackup(cart);
          if (buyBtn) { buyBtn.textContent = 'adicionado ✓'; setTimeout(function () { buyBtn.textContent = prev || 'comprar'; buyBtn.disabled = false; }, 1400); }
        }).catch(function () {
          if (buyBtn) { buyBtn.textContent = prev || 'comprar'; buyBtn.disabled = false; }
          alert('Não foi possível adicionar ao carrinho.');
        });
      });
      update();
      window.__ctApplySize = function (size) { var ok = false; $$('[data-opt][data-size-btn]').forEach(function (b) { if (b.getAttribute('data-value') === size && !b.classList.contains('disabled')) { ok = true; b.click(); } }); return ok; };
    })();

    /* accordion (produto) */
    $$('.accordion').forEach(function (acc) { var h = $('.accordion__head', acc), b = $('.accordion__body', acc), s = $('.accordion__sign', acc); if (!h || !b) return; h.addEventListener('click', function () { var o = b.classList.toggle('open'); if (s) s.textContent = o ? '−' : '+'; }); });

    /* accordion (filtros PLP) */
    $$('.facc').forEach(function (f) { var h = $('.facc__head', f); if (!h) return; h.addEventListener('click', function () { f.classList.toggle('open'); }); });

    /* lightbox (produto) */
    (function () {
      var imgs = $$('#gallery .gallery__item img'), lb = $('#lightbox'); if (!imgs.length || !lb) return;
      var lbImg = $('#lbImg'), cur = 0;
      function vis() { return $$('#gallery .gallery__item img'); }
      function open(im) { var v = vis(); if (!v.length) return; cur = v.indexOf(im); if (cur < 0) cur = 0; lbImg.src = v[cur].dataset.full || v[cur].src; lb.classList.add('open'); }
      function gomo(d) { var v = vis(); if (!v.length) return; cur = (cur + d + v.length) % v.length; lbImg.src = v[cur].dataset.full || v[cur].src; }
      imgs.forEach(function (im) { im.parentElement.addEventListener('click', function (e) { if (e.target.closest('.gallery__wish')) return; open(im); }); });
      var c = $('#lbClose'), nx = $('#lbNext'), pv = $('#lbPrev');
      if (c) c.addEventListener('click', function () { lb.classList.remove('open'); });
      if (nx) nx.addEventListener('click', function () { gomo(1); });
      if (pv) pv.addEventListener('click', function () { gomo(-1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.classList.remove('open'); });
    })();

    /* lightbox das avaliações (fotos reais de clientes) */
    (function () {
      var lb = $('#rvLightbox'); if (!lb) return;
      var im = $('#rvLbImg');
      $$('.js-rvphoto').forEach(function (b) {
        b.addEventListener('click', function () { im.src = b.dataset.full || (b.querySelector('img') || {}).src; lb.classList.add('open'); });
      });
      var c = $('#rvLbClose'); if (c) c.addEventListener('click', function () { lb.classList.remove('open'); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.classList.remove('open'); });
    })();

    /* pontinhos do carrossel de galeria (mobile): indicam quantas fotos e em qual está */
    (function () {
      var gal = $('#gallery'), wrap = $('#galleryDots'); if (!gal || !wrap) return;
      var allItems = $$('.gallery__item', gal); if (allItems.length < 2) return;
      var items = [];
      function render() {
        items = $$('.gallery__item', gal);
        wrap.innerHTML = '';
        if (items.length < 2) return;
        items.forEach(function (it, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'gallery__dot' + (i === 0 ? ' active' : '');
          d.setAttribute('aria-label', 'ir para a foto ' + (i + 1));
          d.addEventListener('click', function () { it.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
          wrap.appendChild(d);
        });
      }
      render();
      window.__ctGalleryDots = render;
      var ticking = false;
      gal.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var dots = $$('.gallery__dot', wrap);
          var center = gal.scrollLeft + gal.clientWidth / 2, best = 0, bd = Infinity;
          items.forEach(function (it, i) { var c = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(c - center); if (dd < bd) { bd = dd; best = i; } });
          dots.forEach(function (d, i) { d.classList.toggle('active', i === best); });
          ticking = false;
        });
      }, { passive: true });
    })();

    /* frete (produto): mesma regra do carrinho por preço — abaixo de R$199 = Padrão R$16; R$199+ = grátis */
    (function () {
      var btn = $('#calcCep'), input = $('#cep'); if (!btn || !input) return;
      var box = $('#freightResult'), data = window.__ctProduct || {};
      var FREE = data.freeShip || 19900;   /* limite de frete grátis (settings.free_shipping_threshold) */
      var STD = 1600;                       /* frete padrão: R$ 16,00 (espelha a taxa fixa "Padrão" da loja) */
      function brl(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
      function show(html, cls) { if (!box) return; box.className = 'freight__result' + (cls ? ' ' + cls : ''); box.innerHTML = html; box.hidden = false; }
      function quote(cep) {
        return shippingRates(cep).then(function (rates) {
          show(rates.length ? freightRatesHtml(rates) : 'nenhuma opção de frete para este CEP.', rates.length ? 'ok' : 'err');
        }, function () { show('não foi possível calcular o frete agora. tente novamente.', 'err'); });
      }
      function calc() {
        var cep = (input.value || '').replace(/\D/g, '');
        if (cep.length !== 8) { show('digite um CEP válido (8 dígitos).', 'err'); return; }
        show('calculando frete…', 'loading');
        /* taxas REAIS do checkout (Correios/Jadlog/Loggi + retirada; frete grátis quando o pedido passa de R$199).
           O endpoint exige item no carrinho: se estiver vazio, adiciona ESTE produto só p/ cotar e restaura. */
        getCart().then(function (cart) {
          if (cart && cart.item_count > 0) return quote(cep);
          var vid = Number((document.getElementById('variant-id') || {}).value) || 0;
          if (!vid) return quote(cep);
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) })
            .then(function () { return quote(cep); })
            .then(function () { return fetch('/cart/clear.js', { method: 'POST' }); });
        }).catch(function () { show('não foi possível calcular o frete agora. tente novamente.', 'err'); });
      }
      input.addEventListener('input', function () { var v = input.value.replace(/\D/g, '').slice(0, 8); input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
      btn.addEventListener('click', calc);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calc(); } });
    })();

    /* provador virtual (produto): modo rápido (altura/peso, por IMC) ou por medidas (busto/cintura/quadril) */
    (function () {
      var overlay = $('#sbOverlay'); if (!overlay) return;
      var bar = $('#sbBar'), nextBtn = $('#sbNext'), backBtn = $('#sbBack');
      var state = { altura: 165, peso: 62, busto: 90, cintura: 70, quadril: 98 };
      var flows = { rapido: ['stepAltura', 'stepPeso', 'stepResult'], medidas: ['stepBusto', 'stepCintura', 'stepQuadril', 'stepResult'] };
      var mode = null, cur = 0;
      function open() { mode = null; cur = 0; render(); overlay.classList.add('open'); }
      function close() { overlay.classList.remove('open'); }
      var op = $('#openSizebay'); if (op) op.addEventListener('click', open);
      var cl = $('#sbClose'); if (cl) cl.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      function bind(id, key, vid) { var r = $('#' + id), v = $('#' + vid); if (!r) return; r.addEventListener('input', function () { state[key] = +r.value; if (v) v.textContent = r.value; }); }
      bind('rAltura', 'altura', 'vAltura'); bind('rPeso', 'peso', 'vPeso');
      bind('rBusto', 'busto', 'vBusto'); bind('rCintura', 'cintura', 'vCintura'); bind('rQuadril', 'quadril', 'vQuadril');
      $$('.sb-mode', overlay).forEach(function (b) { b.addEventListener('click', function () { mode = b.getAttribute('data-mode'); cur = 0; render(); }); });
      /* rápido: IMC calibrado (1,77m/72kg = M). medidas: cruza com a tabela pela MAIOR medida p/ não ficar apertado */
      function compute() {
        var s = ['PP', 'P', 'M', 'G', 'GG'], idx;
        if (mode === 'rapido') {
          var h = state.altura / 100, bmi = state.peso / (h * h);
          if (bmi < 18.5) idx = 0; else if (bmi < 21) idx = 1; else if (bmi < 24.5) idx = 2; else if (bmi < 28.5) idx = 3; else idx = 4;
          return { size: s[idx], idx: idx };
        }
        function band(v, t) { for (var i = 0; i < t.length; i++) { if (v <= t[i]) return i; } return 4; }
        idx = Math.max(band(state.busto, [82, 88, 94, 100]), band(state.cintura, [64, 70, 76, 84]), band(state.quadril, [92, 98, 104, 110]));
        return { size: s[idx], idx: idx };
      }
      function showResult() { var r = compute(); var sz = $('#sbSize'); if (sz) sz.textContent = r.size; var bars = $('#sbBars'); if (bars) bars.innerHTML = ['PP', 'P', 'M', 'G', 'GG'].map(function (s, i) { return '<span class="' + (i === r.idx ? 'hit' : '') + '">' + s + '</span>'; }).join(''); }
      function render() {
        $$('.sb-step', overlay).forEach(function (s) { s.classList.remove('active'); });
        if (!mode) { var m = $('#stepMode'); if (m) m.classList.add('active'); if (bar) bar.style.width = '0%'; if (backBtn) backBtn.style.display = 'none'; if (nextBtn) nextBtn.style.display = 'none'; return; }
        if (nextBtn) nextBtn.style.display = '';
        var f = flows[mode], id = f[cur], el = $('#' + id); if (el) el.classList.add('active');
        if (id === 'stepResult') showResult();
        if (bar) bar.style.width = ((cur + 1) / f.length * 100) + '%';
        if (backBtn) backBtn.style.display = 'block';
        if (nextBtn) nextBtn.textContent = (cur === f.length - 1) ? 'selecionar tamanho' : (cur === f.length - 2) ? 'ver meu tamanho' : 'continuar';
      }
      if (nextBtn) nextBtn.addEventListener('click', function () { if (!mode) return; var f = flows[mode]; if (cur < f.length - 1) { cur++; render(); } else { var size = ($('#sbSize') || {}).textContent || ''; var ok = window.__ctApplySize ? window.__ctApplySize(size) : false; if (!ok) alert('Seu tamanho ideal é ' + size + '. No momento ele está indisponível.'); close(); } });
      if (backBtn) backBtn.addEventListener('click', function () { if (!mode) return; if (cur > 0) { cur--; render(); } else { mode = null; render(); } });
    })();

    /* tabela de medidas (produto) */
    (function () {
      var overlay = $('#scOverlay'); if (!overlay) return;
      function open() { overlay.classList.add('open'); }
      function close() { overlay.classList.remove('open'); }
      var op = $('#openSizeChart'); if (op) op.addEventListener('click', open);
      var cl = $('#scClose'); if (cl) cl.addEventListener('click', close);
      var ok = $('#scOk'); if (ok) ok.addEventListener('click', close);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    })();

    /* swatch highlight em cards */
    document.addEventListener('click', function (e) { var s = e.target.closest('.pcard__swatches span'); if (!s) return; s.parentElement.querySelectorAll('span').forEach(function (x) { x.classList.remove('sel'); }); s.classList.add('sel'); });

    /* header search toggle */
    (function () {
      var tog = $('#searchToggle'), bar = $('#headerSearchbar'), close = $('#searchClose');
      if (!tog || !bar) return;
      tog.addEventListener('click', function () { bar.classList.toggle('open'); if (bar.classList.contains('open')) { var inp = bar.querySelector('input'); if (inp) inp.focus(); } });
      if (close) close.addEventListener('click', function () { bar.classList.remove('open'); });
    })();

    /* ===== PÁGINA DA SACOLA: embalagem p/ presente, upsell, copiar cupom ===== */
    (function () {
      var cartWrap = $('.cart-wrap'); if (!cartWrap) return;

      /* calcular frete real do carrinho (mesmas taxas do checkout: Melhor Envio) */
      (function () {
        var input = $('[data-cep-input]', cartWrap), btn = $('[data-cep-calc]', cartWrap), box = $('[data-cep-result]', cartWrap);
        if (!input || !btn) return;
        function show(html, cls) { if (!box) return; box.className = 'summary__cep-result' + (cls ? ' ' + cls : ''); box.innerHTML = html; box.hidden = false; }
        function run() {
          var cep = (input.value || '').replace(/\D/g, '');
          if (cep.length !== 8) { show('digite um CEP válido (8 dígitos).', 'err'); return; }
          btn.disabled = true; var old = btn.textContent; btn.textContent = '...';
          show('calculando frete…', 'loading');
          shippingRates(cep).then(function (rates) {
            btn.disabled = false; btn.textContent = old;
            show(rates.length ? freightRatesHtml(rates) : 'nenhuma opção de frete para este CEP.', rates.length ? 'ok' : 'err');
          }).catch(function () { btn.disabled = false; btn.textContent = old; show('não foi possível calcular agora. tente de novo.', 'err'); });
        }
        input.addEventListener('input', function () { var v = input.value.replace(/\D/g, '').slice(0, 8); input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
        btn.addEventListener('click', run);
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      })();

      /* copiar código do cupom (clique no código) */
      function legacyCopy(t) { try { var a = document.createElement('textarea'); a.value = t; a.style.position = 'fixed'; a.style.opacity = '0'; document.body.appendChild(a); a.select(); document.execCommand('copy'); document.body.removeChild(a); } catch (e) {} }
      $$('[data-copy-code]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.getAttribute('data-copy-code') || '';
          var label = btn.querySelector('span');
          function done() {
            btn.classList.add('copied');
            if (label) { var t = label.textContent; label.textContent = 'copiado!'; setTimeout(function () { label.textContent = t; btn.classList.remove('copied'); }, 1700); }
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, function () { legacyCopy(code); done(); });
          } else { legacyCopy(code); done(); }
        });
      });

      /* cupom de boas-vindas: aplicar -> registra no Shopify e troca o status p/ "aplicado" */
      (function () {
        var ticket = $('[data-coupon]'); if (!ticket) return;
        var code = (ticket.getAttribute('data-coupon-code') || '').toUpperCase();
        var STORE_KEY = 'contts_coupon_applied';
        var stored = ''; try { stored = (localStorage.getItem(STORE_KEY) || '').toUpperCase(); } catch (e) {}
        /* já aplicado (detectado pelo Liquid) ou marcado localmente numa visita anterior */
        if (ticket.getAttribute('data-applied') === 'true' || (code && stored === code)) {
          ticket.classList.add('is-applied');
        }
        var applyBtn = ticket.querySelector('[data-coupon-apply]');
        if (applyBtn) applyBtn.addEventListener('click', function () {
          if (ticket.classList.contains('is-applied') || applyBtn.disabled) return;
          applyBtn.disabled = true; applyBtn.textContent = 'aplicando...';
          function applied() {
            try { localStorage.setItem(STORE_KEY, code); } catch (e) {}
            ticket.classList.add('is-applied');
            /* recarrega para o resumo mostrar subtotal, linha de desconto e total real */
            location.reload();
          }
          /* registra o cupom na sessão do Shopify (carrega até o checkout) */
          fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
            .then(applied, function () {
              /* fallback: aplica via navegação caso o fetch falhe */
              try { localStorage.setItem(STORE_KEY, code); } catch (e) {}
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
            });
        });
      })();

      /* embalagem para presente: marca = adiciona o produto; desmarca = remove */
      var gw = $('[data-giftwrap]');
      if (gw) gw.addEventListener('change', function () {
        var id = gw.getAttribute('data-variant'); gw.disabled = true;
        if (gw.checked) {
          addToCart(id, 1).then(function () { location.reload(); })
            .catch(function () { gw.disabled = false; gw.checked = false; alert('Não foi possível adicionar a embalagem.'); });
        } else {
          getCart().then(function (cart) {
            var line = cart.items.filter(function (i) { return String(i.variant_id) === String(id); })[0];
            if (!line) { location.reload(); return; }
            return changeLine(line.key, 0).then(function () { location.reload(); });
          }).catch(function () { gw.disabled = false; gw.checked = true; });
        }
      });

      /* upsell "leve também" agora é LISTA FIXA renderizada no Liquid (templates/cart.liquid) */

      /* adicionar do upsell → adiciona e recarrega (atualiza sacola, frete e total) */
      cartWrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cart-add]'); if (!b) return;
        e.preventDefault(); var id = b.getAttribute('data-cart-add'); b.disabled = true; var old = b.textContent; b.textContent = 'adicionando...';
        addToCart(id, 1).then(function () { location.reload(); }).catch(function () { b.disabled = false; b.textContent = old; });
      });

      /* stepper de quantidade (−/+): altera a linha via AJAX e recarrega para refletir os totais */
      cartWrap.addEventListener('click', function (e) {
        var dec = e.target.closest('[data-qty-dec]'), inc = e.target.closest('[data-qty-inc]');
        if (!dec && !inc) return;
        var box = e.target.closest('[data-qtybox]'); if (!box) return;
        var input = box.querySelector('[data-qty-input]'); var key = box.getAttribute('data-key');
        var cur = parseInt(input.value, 10) || 0; var next = inc ? cur + 1 : Math.max(0, cur - 1);
        if (next === cur) return;
        box.querySelectorAll('button').forEach(function (b) { b.disabled = true; }); input.value = next;
        changeLine(key, next).then(function () { location.reload(); })
          .catch(function () { box.querySelectorAll('button').forEach(function (b) { b.disabled = false; }); input.value = cur; });
      });
    })();
  });
})();
